import { render, staticRenderFns } from "./WoundMappingModal.vue?vue&type=template&id=ab167b94&scoped=true&"
import script from "./WoundMappingModal.vue?vue&type=script&lang=js&"
export * from "./WoundMappingModal.vue?vue&type=script&lang=js&"
import style0 from "./WoundMappingModal.vue?vue&type=style&index=0&id=ab167b94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab167b94",
  null
  
)

export default component.exports